import Button from '@app-studio-web/ui/components/Button'
import Layout from '@app-studio-web/ui/components/Layout'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'personalityType'

export default function PersonalityTypePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [sliderValue, setSliderValue] = useState(1000)
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    // Convert slider value to personality type
    const personalityType = sliderValue <= 800 ? 'practical' : 'dreamy'

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Which describes you more?',
      answer_key: personalityType,
      answer: personalityType,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  return (
    <Layout>
      <Form
        className="flex h-full flex-col"
        method="post"
        onSubmit={handleSubmit}
      >
        <div className="mt-8">
          <h1 className="custom-heading text-center text-3xl whitespace-pre-line">
            {t('pages.onboarding.personalityType.heading')}
          </h1>
        </div>

        <div className="flex flex-1 flex-col items-center justify-center gap-8 px-4">
          <div className="relative w-full max-w-[500px]">
            <label htmlFor="personality-slider" className="sr-only">
              Personality type slider
            </label>
            <input
              id="personality-slider"
              type="range"
              value={sliderValue}
              min="100"
              max="1500"
              onChange={(e) => setSliderValue(Number(e.target.value))}
              className="slider-black-thumb h-2 w-full cursor-pointer appearance-none rounded-lg bg-[#6A6A6A4D]"
            />
            <div className="mt-2 flex justify-between">
              <span className="max-w-[80px] text-center font-bold">
                {t('pages.onboarding.personalityType.options.practical')}
              </span>
              <span className="max-w-[80px] text-center font-bold">
                {t('pages.onboarding.personalityType.options.dreamy')}
              </span>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-auto mb-8 flex w-full max-w-[500px] flex-col gap-4">
          <Button
            title={t('shared.continue')}
            type="submit"
            dataTestId="button-continue-slider"
          />
        </div>
      </Form>
    </Layout>
  )
}
